import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'

const endpoint = `${apiUrl.stable}/recarga`

/**
 * Returns the automatic recharge state of the signed user's company
 * @returns {Promise.<{ data: ApiRechargeInfo }>}
 */
export const getRechargeState = () => {
  const url = `${endpoint}/obtem`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers })
}

/**
* Enables the automatic recharge in the signed user's company
* @param {number} amount - How much will be recharged
* @param {number} triggerAmount - Below of which balance amount will trigger the recharge
* @param {number} creditCardId - The credit card id that will be charged
*/
export const enableRecharge = (amount, triggerAmount, creditCardId) => {
  const url = `${endpoint}/cadastra`

  const data = {
    amount,
    triggerAmount,
    creditCardId,
  }

  const headers = {
    ...jsonWebToken.header
  }

  return axios.post(url, data, { headers })
}

/**
* Disable the automatic recharge in the signed user's company
*/
export const disableRecharge = () => {
  const url = `${endpoint}/remove`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.delete(url, { headers })
}

/**
* Pauses anything that may trigger a automatic recharge
*/
export const pauseRecharge = () => {
  const url = `${endpoint}/desabilita`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.delete(url, { headers })
}

/**
* Resume the default automatic recharge trigger behaviour
*/
export const resumeRecharge = () => {
  const url = `${endpoint}/habilita`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.put(url, null, { headers })
}

export default {
  getRechargeState,
  enableRecharge,
  disableRecharge,
  pauseRecharge,
  resumeRecharge,
  getState: getRechargeState,
  enable: enableRecharge,
  disable: disableRecharge,
  pause: pauseRecharge,
  resume: resumeRecharge,
}